import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {Tooltip} from "antd";
import React from "react";
import {observer} from "mobx-react";
import {
    ContainerUnreadIndicator, ContentUnreadIndicator,
    UnreadIndicator
} from "@dropDesk/presentation/pages/chat/ui/unread_tile_notification/styled";


const UnreadTileNotification = observer((
    {}: {}
) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    return (
        <ContainerUnreadIndicator>
            <Tooltip title={'Você possui mensagens não lidas'}>
                <ContentUnreadIndicator>
                    <UnreadIndicator color={colors.textError}/>
                </ContentUnreadIndicator>
            </Tooltip>
        </ContainerUnreadIndicator>
    )
});
export default UnreadTileNotification;
